/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesEdit } from "../funcs/killswitchesEdit.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchMutationReceipt } from "../models/components/killswitchmutationreceipt.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { KillswitchConflict } from "../models/errors/killswitchconflict.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesEditRequest,
  KillswitchesEditSecurity,
} from "../models/operations/killswitchesedit.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type EditKillswitchMutationVariables = {
  security: KillswitchesEditSecurity;
  request: KillswitchesEditRequest;
  options?: RequestOptions;
};

export type EditKillswitchMutationData = KillswitchMutationReceipt;

export type EditKillswitchMutationError =
  | KillswitchConflict
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * edit killswitches
 */
export function useEditKillswitchMutation(
  options?: MutationHookOptions<
    EditKillswitchMutationData,
    EditKillswitchMutationError,
    EditKillswitchMutationVariables
  >,
): UseMutationResult<
  EditKillswitchMutationData,
  EditKillswitchMutationError,
  EditKillswitchMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildEditKillswitchMutation(client, options),
    ...options,
  });
}

export function mutationKeyEditKillswitch(): MutationKey {
  return ["@gram/client", "killswitches", "edit"];
}

export function buildEditKillswitchMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: EditKillswitchMutationVariables,
  ) => Promise<EditKillswitchMutationData>;
} {
  return {
    mutationKey: mutationKeyEditKillswitch(),
    mutationFn: function editKillswitchMutationFn({
      security,
      request,
      options,
    }): Promise<EditKillswitchMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(killswitchesEdit(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}
